import type { ReactNode } from 'react';
import { AxiosError } from 'axios';
import { ErrorBoundary as ReactErrorBoundary, FallbackProps } from 'react-error-boundary';
import { ServerErrorPage } from '@app/pages/shared';
import NoMatchPage from '@app/pages/shared/NoMatch';
import { isMaintenanceMode } from '@data/utils/helpers';

export const ErrorBoundary = ({ children }: { children: ReactNode }) => {
  function FallbackComponent({ error }: FallbackProps) {
    const axiosError = error as AxiosError;
    return (
      <div>
        {axiosError?.response?.status === 404 ? (
          <NoMatchPage />
        ) : (
          (!axiosError?.response?.status ||
            (!isMaintenanceMode(axiosError) && axiosError?.response?.status >= 500)) && (
            <ServerErrorPage />
          )
        )}
      </div>
    );
  }

  return <ReactErrorBoundary FallbackComponent={FallbackComponent}>{children}</ReactErrorBoundary>;
};
